import React from "react";
import { CircleCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { personaItems } from "../data/landing";
export function PersonaSection() {
  return <section className="bg-white" data-id="element-209" data-mp="7xncdfe1mic1">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24" data-id="element-210" data-mp="7yooln6spavc">
        <SectionHeading eyebrow="Is This Right for Your Family?" title="This Collection Is for You If…" data-id="element-211" data-mp="cvowm3n7gnp3" />

        <ol className="mt-10 space-y-3" data-id="element-212" data-mp="10lj92k3m4a8t">
          {personaItems.map((item, i) => <li key={item} className="flex items-start gap-4 rounded-2xl bg-canvas p-5 md:p-6" data-id="element-213" data-mp="14nwd942po03h" data-mpi={i}>
              <CircleCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-leaf" strokeWidth={2.25} aria-hidden="true" data-id="element-214" data-mp="qo4r2g21jdee" />
              <div data-id="element-215" data-mp="vlwr5xcua5to">
                <span className="font-display text-xs font-extrabold tracking-wider text-gold-deep" data-id="element-216" data-mp="vl4xis2syi61">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="mt-0.5 text-[17px] leading-relaxed text-ink" data-id="element-217" data-mp="3gd70jzzuxak8">{item}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold leading-snug text-navy" data-id="element-218" data-mp="1sn4jlfsqwbyx">
          If you've ever wondered whether your child truly understands WHY they believe, this collection gives your
          family a place to begin.
        </p>
      </div>
    </section>;
}